import { useLocation } from "react-router-dom";
import { useDisclosure, UseDisclosureReturn, Flex } from "@chakra-ui/react";
import { useContext, useEffect, createContext, ReactNode } from "react";
import Header from "../Components/Header";
import { Sidebar } from "../Components/Sidebar";

interface SidebarDrawerProviderProps {
  children: ReactNode;
}

type SidebarDrawerContextData = UseDisclosureReturn;

const SidebarDrawerContext = createContext({} as SidebarDrawerContextData);

export function SidebarDrawerProvider({
  children,
}: SidebarDrawerProviderProps) {
  const disclosure = useDisclosure();
  const location = useLocation();
  // Caso a condição seja true, hiddenHeaderAndSidebar irá esconder a Sidebar e o Header
  // const hiddenHeaderAndSidebar = location.pathname === "/";

  useEffect(() => {
    disclosure.onClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <SidebarDrawerContext.Provider value={disclosure}>
      {/* {!hiddenHeaderAndSidebar ? ( */}
      <Flex direction="column" h="100vh" maxH="100vh" overflow="hidden">
        <Header />
        <Flex w="100%" mx="auto" flex="1">
          <Sidebar />
          <Flex
            overflow="auto"
            w="100%"
            maxHeight="calc(100vh - 100px)"
            h="100vh"
            mx="auto"
          >
            {children}
          </Flex>
        </Flex>
      </Flex>
      {/* ) : (
        children
      )} */}
    </SidebarDrawerContext.Provider>
  );
}

export const useSidebarDrawer = () => useContext(SidebarDrawerContext);
